import type {
  CommunityGroupCreateRequest,
  CommunityGroupDetailsV2Dto,
  CommunityGroupEditRequest,
  CommunityGroupV2Dto,
  UserRoleCommunityGroupPermissionsDto,
  UserRoleDto,
} from "@/api/types";
import { createFormPermissions, toPermissionsRequest } from "@/helpers/permissions";

import type { CreateOrEditCommunityGroupFormValues } from "./CommunityGroupForm";

export function createCommunityGroupFormValues({
  defaultPermissions,
  group,
  roles,
  type,
}: {
  defaultPermissions: UserRoleCommunityGroupPermissionsDto[];
  group: CommunityGroupDetailsV2Dto | undefined;
  roles: UserRoleDto[];
  type: CommunityGroupV2Dto["type"];
}): CreateOrEditCommunityGroupFormValues {
  return {
    name: group?.name || "",
    description: group?.description || "",
    audience: group?.audience || [],
    icon: group?.icon,
    type,
    image: group?.image ? [group.image] : [],
    permissions: createFormPermissions(roles, defaultPermissions, group?.permissions),
    isRealEstate: group?.type === "realEstate",
    isAllResidentsAdded: false,
    postingLevel: group?.postingLevel,
    enabled: !group?.disabled,
  };
}

export function createCommunityGroupRequest(
  values: CreateOrEditCommunityGroupFormValues,
): CommunityGroupCreateRequest | CommunityGroupEditRequest {
  return {
    name: values.name,
    description: values.description,
    icon: values.icon!,
    audience: values.audience,
    permissions: toPermissionsRequest(values.permissions),
    addAllResidents: !values.isRealEstate && values.isAllResidentsAdded,
  };
}

export function getMultiProjectGroupType(
  group: CommunityGroupDetailsV2Dto | undefined,
): "system" | "connection" | undefined {
  if (group?.systemGroupId) {
    return "system";
  }
  if (group?.projectConnectionGroupId) {
    return "connection";
  }

  return undefined;
}
